import React from "react";
import "./customer.css";
import { useParams } from "react-router-dom";
import Loading from "../../Loading";
import Students from "./components/Students";
import UnpaidBills from "./components/UnpaidBills";
import SalesInfo from "./components/SalesInfo";
import Recent from "./components/Recent";
import Lang from "../../components/Lang";
import Error from "../../components/Error";
import useDB from "../../hooks/useDB";
import EditCare from "./components/EditCare";
import BasicInfo from "./components/BasicInfo";
import HtTabs from "../../components/HtTabs";


export default function Customer() {
  let { id } = useParams();
  const [customer,setCustomer,error,loading] = useDB(`/customer/${id}`)
  const [editCustomer, setEditCustomer] = React.useState(false);
  /* const [value, setValue] = React.useState(0); */



/*   const updateCustomer = async () => {
    net
      .post(`/customers/${customer.get._id}/update`, {
        ...customer,
        students: undefined,
      })
      .then((r) => {
        setCustomer({...customer,...r});
      });
  }; */

  if (loading) return <Loading />;
  if (error) return <Error />;

 /*  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  let unpaidBills = 0;
  customer.students.forEach((s) => {
    unpaidBills += s.unpaidBills.length;
  }); */

  // console.log(customer);
  return (
    <div className="customer-page-container">
      <div className="customer-header-card">
        <BasicInfo customer={customer} />
        <EditCare
          customer={customer}
          setCustomer={setCustomer}
          editCustomer={editCustomer}
          setEditCustomer={setEditCustomer}
        />
      </div>

      <div className="customer-roster-section">
        <Students customer={customer} />
      </div>

      <div className="customer-tabs-section">
        <HtTabs
          labels={[
            <Lang w="recent" />,
            <Lang w="general" />,
            <Lang w="unpaidBills" />,
            <Lang w="notes" />,
            <Lang w="history" />,
          ]}
          components={[
            <Recent customer={customer} />,
            <SalesInfo customer={customer} setCustomer={setCustomer} />,
            <UnpaidBills customer={customer} setCustomer={setCustomer} />,
          ]}
        />
      </div>
    </div>
  );
}
